import type { QCResultStatsResult } from "@/modules/qc/domain/types/result";
import { Card } from "@devhop/ui";

type QCResultProblemsProps = {
  stats: QCResultStatsResult;
};

export function QCResultProblems({ stats }: QCResultProblemsProps) {
  if (stats.commonProblems.length === 0) return null;

  return (
    <Card className="p-6" data-tourid="result-problems">
      <h2 className="mb-4 font-semibold text-lg">ບັນຫາທີ່ພົບເລື້ອຍ</h2>
      <div className="space-y-3">
        {stats.commonProblems.map((problem, index) => (
          <div
            key={problem.qcStandardItemId}
            className="rounded-lg border p-4 hover:bg-muted/50"
          >
            <div className="mb-2 flex items-start justify-between">
              <div className="flex-1">
                <div className="mb-1 flex items-center gap-2">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-red-500 font-bold text-white text-xs">
                    {index + 1}
                  </span>
                  <span className="font-medium">{problem.title}</span>
                </div>
                <p className="text-muted-foreground text-sm">
                  ພົບ {problem.count} ຄັ້ງ
                </p>
              </div>
            </div>
            {problem.sampleNotes && (
              <div className="mt-2 rounded bg-muted p-2 text-sm">
                <span className="font-medium">ຕົວຢ່າງ:</span>{" "}
                {problem.sampleNotes}
              </div>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
}
